












































import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'KESfImage',
  props: {
    src: {
      type: String,
      required: false
    },
    srcsets: {
      type: Array,
      default: () => [],
      validator: (
        value: { resolution: string; src: string; width: string }[]
      ) =>
        value.length === 0 ||
        value.every((item) => item.resolution && item.src) ||
        value.every((item) => item.src && item.width)
    },
    alt: {
      type: String,
      required: true,
      default: ''
    },
    width: {
      type: Number,
      default: null
    },
    height: {
      type: Number,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    loading: {
      type: String,
      default: 'lazy',
      validator: (value: string) => ['', 'lazy', 'eager'].includes(value)
    },
    imageTag: {
      type: String,
      default: 'atoms-image-or-fallback',
      validator: (value: string) =>
        ['', 'img', 'atoms-image-or-fallback'].includes(value)
    },
    preload: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loaded: false
    };
  },
  computed: {
    sortedSrcsets() {
      const arr = [...this.srcsets];

      arr.sort((setA, setB) =>
        setA.width && setB.width
          ? Number.parseInt(setA.width) - Number.parseInt(setB.width)
          : Number.parseInt(setA.resolution) - Number.parseInt(setB.resolution)
      );
      return arr;
    },
    srcset() {
      return this.sortedSrcsets.reduce(
        (str, set) =>
          `${this.prefix(str)}${set.src} ${this.srcsetDescriptor(set)}`,
        ''
      );
    },
    sizes() {
      const hasBreakpoints = this.sortedSrcsets.every(
        (set) => set.breakpoint && set.width
      );

      if (!hasBreakpoints) return null;

      return this.sortedSrcsets.reduce(
        (str, set) =>
          `${this.prefix(str)}${this.formatBreakpoint(
            set.breakpoint
          )}${this.formatDimension(set.width)}`,
        ''
      );
    },
    classes() {
      if (this.loaded) {
        return 'sf-image sf-image-loaded';
      } else {
        return 'sf-image';
      }
    },
    imageStyle() {
      return {
        '--image-width':
          typeof this.width === 'string'
            ? this.formatDimension(this.width)
            : `${this.width}px`,
        '--image-height':
          typeof this.height === 'string'
            ? this.formatDimension(this.height)
            : `${this.height}px`
      };
    },
    imageComponentTag() {
      return !this.$nuxt ? 'img' : this.imageTag || 'img';
    },
    attributes() {
      return this.imageTag === 'img' || this.imageTag === ''
        ? {
            ...this.$attrs,
            sizes: this.sizes,
            srcset: this.srcset
          }
        : {
            ...this.$attrs,
            width: this.width ? this.width : null,
            height: this.height ? this.height : null
          };
    }
  },
  methods: {
    onLoad() {
      this.loaded = true;
    },
    formatResolution(resolution) {
      return String(resolution).endsWith('x') ? resolution : `${resolution}x`;
    },
    formatDimension(size) {
      if (
        ['%'].includes(`${size}`.slice(-1)) ||
        ['rem'].includes(`${size}`.slice(-3)) ||
        ['em', 'px', 'vw', 'vh'].includes(`${size}`.slice(-2)) ||
        !parseInt(size, 10)
      ) {
        return size;
      } else {
        return `${size}px`;
      }
    },
    formatBreakpoint(breakpoint) {
      return breakpoint ? `(max-width: ${breakpoint}px) ` : '';
    },
    prefix(str) {
      return str ? `${str}, ` : '';
    },
    srcsetDescriptor(srcset) {
      return srcset.width
        ? `${Number.parseInt(srcset.width) || ''}w`
        : this.formatResolution(srcset.resolution);
    }
  }
});
